<template>
  <switch-dialog :visible="visible" @cancel="close">
    <div class="hotel-list" v-if="list.length">
      <div
        class="hotel-item"
        v-for="item in list"
        :class="{ 'no-price': !(priceVisible && item.min_price > 1) }"
        :key="item.id"
        @click="select(item)"
      >
        <div class="cover" :style="{ backgroundImage: `url(${item.cover})` }">
          <!-- <img src="../images/icon_360.png" class="icon" /> -->
        </div>
        <div class="title ellipsis">{{ item.name }}</div>
        <div v-if="priceVisible && item.min_price > 1" class="desc ellipsis">
          ¥{{ item.min_price }}起
        </div>
      </div>
    </div>
    <div class="blank-wrap" v-else>
      <img src="../images/blank.png" class="blank-icon" />
      <span>暂无其他方案</span>
    </div>
  </switch-dialog>
</template>

<script>
import qs from "@halobear/utils/qs";

import switchDialog from "@/components/switch-dialog";

export default {
  components: {
    switchDialog,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    priceVisible() {
      const route = this.$route;
      const query = route.query.hall_id
        ? route.query
        : qs.parse(window.location.search.split("?")[1] || "");
      return !query.phone;
    },
  },
  methods: {
    close() {
      this.$emit("update:visible", false);
    },
    select(item) {
      this.close();
      this.$emit("select", item.pano_id);
    },
  },
};
</script>

<style lang="less" scoped>
.hotel-list {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  display: flex;
  align-items: center;
  flex: 1;
  justify-content: space-between;
  flex-wrap: wrap;
  &::-webkit-scrollbar {
    display: none;
  }
  .hotel-item {
    height: 380px;
    width: 370px;
    text-align: center;
    &.no-price {
      height: 340px;
    }
  }
  .cover {
    width: 370px;
    height: 246px;
    background-color: #eee;
    position: relative;
    display: block;
  }
  .icon {
    width: 64px;
    height: 64px;
    position: absolute;
    left: 12px;
    bottom: 12px;
  }
  .title {
    font-weight: bold;
    color: #333;
    font-size: 26px;
    padding: 20px 10px 4px;
  }
  .desc {
    font-size: 24px;
    font-weight: bold;
    color: #323038;
    line-height: 34px;
  }
}
.blank-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #999;
  font-size: 30px;
  padding: 80px 0;
  .blank-icon {
    width: 330px;
    height: 330px;
    object-fit: contain;
    object-position: center center;
    margin-bottom: 60px;
  }
}
</style>
